/**
 * @desc 平台-列表查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlatformResponseDto>>;
export function request(
  params: API.basics.platform.getList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platform/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
